import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  ListProps,
} from 'react-admin'

const ListCommentFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
    </Filter>
  )
}

export const ListCommentQuestions: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      // filters={<ListCommentFilter />}
      {...rest}
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Título" source="title" />
        <TextField label="Descrição" source="descrição" />
      </Datagrid>
    </List>
  )
}
